// Edit tips / timings for the Capsule Corp loader here
export const LOADER_TIPS = [
  'Collect Dragon Balls as they spawn around the site to summon Shenron and make a wish!',
  'You can use Zeni to customize your experience in the shop!',
  'You can buy more Zeni if you run out!',
  'Add friends by clicking their profile picture in chat, then send them direct messages!',
  'Start a video call with a friend, then hit Watch Together to watch episodes in sync!',
  'Activate the Evil Containment Wave from the shop to seal away ads across the site!',
  'Show off with avatar frames from the shop, they appear next to your name in chat!',
  'Check your Inventory to see and equip everything you have bought.',
  'On mobile, double-tap the left or right side of the video to skip 10 seconds!',
  'Change playback speed from the player toolbar, up to 2x!',
  'Use the download button in the player to save an episode for later.',
  'Leave mid-episode? Dragon TV remembers where you stopped and offers to resume.',
  'Made a typo? Hover your own chat message to edit or delete it.',
  'Send images and GIFs in chat with the buttons next to the message box.',
  'Tap the floating capsule in the corner to chat from any page.',
  'Create group chats to hang out with more than one friend at a time.',
  'Climb the Leaderboard by chatting with the community!',
  'Link your Discord account to Dragon TV through our Discord bot!',
  'Want your own ad on Dragon TV? Click any "Your ad could be here" space!',
  'See something wrong? Use the report button and the team will take a look.',
];
export const TIP_ROTATE_MS = 4500;
export const SHOW_DELAY_MS = 180;      // avoid flashing the loader for very quick loads
export const SLOW_LOAD_MS = 15000;     // offer a retry if loading takes this long
export const EXIT_FADE_MS = 520;       // matches .cc-overlay transition
export const MIN_SEQUENCE_MS = 2100;   // once shown, let the capsule poof + screen open finish
export const POP_MS = 1200;            // matches --cc-pop-at in capsule.css
export const POOF_CLEAR_MS = 650;      // after the pop, how long the smoke lingers before fading into the page
// No capsule loader on these routes (chat switching, shop)
export const QUIET_ROUTES = ['/chat', '/dm', '/groups', '/channels', '/shop'];

// Smoke puffs: offset (px), size (% of stage), scale, delay (s)
export const PUFFS = [
  { dx: -96, dy: -22, size: 40, s: 1.15, d: 0 },
  { dx: 88, dy: -38, size: 36, s: 1.1, d: 0.03 },
  { dx: -52, dy: 54, size: 38, s: 1.05, d: 0.05 },
  { dx: 66, dy: 50, size: 40, s: 1.15, d: 0.02 },
  { dx: 0, dy: -74, size: 34, s: 1.05, d: 0.06 },
  { dx: -122, dy: 38, size: 26, s: 0.95, d: 0.09 },
  { dx: 124, dy: 12, size: 28, s: 0.95, d: 0.08 },
  { dx: 0, dy: 8, size: 56, s: 1.3, d: 0 },
];
export const BURST_ANGLES = [0, 45, 90, 135, 180, 225, 270, 315];
export const ORBIT = [
  { a: 0, ball: 'https://customer-assets.emergentagent.com/job_dragon-sphere-tv/artifacts/kv5nzwc2_1773125873429.webp', bd: '0s' },   // 4-star
  { a: 120, ball: 'https://customer-assets.emergentagent.com/job_dragon-sphere-tv/artifacts/hhe81ar1_1773126062388.png', bd: '-.5s' }, // 7-star
  { a: 240, ball: 'https://customer-assets.emergentagent.com/job_dragon-sphere-tv/artifacts/p36ow0li_1773126108746.webp', bd: '-1s' },  // 1-star
];
export const SPARKLES = [
  { left: '12%', top: '18%', d: '0s' },
  { left: '84%', top: '24%', d: '.8s' },
  { left: '78%', top: '80%', d: '1.5s' },
  { left: '18%', top: '76%', d: '1.1s' },
];
